import { render, staticRenderFns } from "./redirectUrlComponent.vue?vue&type=template&id=1fa2f4e3&scoped=true"
import script from "./redirectUrlComponent.vue?vue&type=script&lang=js"
export * from "./redirectUrlComponent.vue?vue&type=script&lang=js"
import style0 from "./redirectUrlComponent.vue?vue&type=style&index=0&id=1fa2f4e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa2f4e3",
  null
  
)

export default component.exports